import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import { useGlobalState } from "../../components/globalState/GlobalStateProvider";
import { TabPanel, TabView } from 'primereact/tabview';
import Consumo from './Consumo';
import ConsumoCliente from './ConsumoCliente';
 
 
export default function ConsumoMain() {
  const { t } = useTranslation();
  const {state} = useGlobalState();
 
  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-chart-bar" style={{ fontSize: '2.0rem' }}></i> {t('gestaoConsumo')}</h1>
            </div>     
          </div>
      </div>
       
      <TabView>
        <TabPanel header="Consumo realizado" leftIcon="pi pi-chart-pie mr-2">
           <Consumo></Consumo>
        </TabPanel>
        {!state.user.cliente && (
          <TabPanel header="Consumo cliente" leftIcon="pi pi-chart-line mr-2">
            <ConsumoCliente></ConsumoCliente>
          </TabPanel>
        )}
    </TabView>
      
    </Container>
  )
}